import { DOWNLOAD, SITE } from "@/data/content";
import { PlayStoreIcon } from "@/components/decor";
import { Reveal, SectionHead } from "@/components/Reveal";

function PhoneMock() {
  return (
    <div
      className="relative mx-auto w-phone rounded-phone border border-white/15 bg-navy-900 p-2 pt-4 shadow-[0_60px_120px_-40px_rgba(0,0,0,0.7)] sm:w-phone-lg"
      data-testid="download-phone-mock"
    >
      <div
        className="absolute left-1/2 top-1.5 z-10 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-navy-950 ring-1 ring-white/20"
        aria-hidden="true"
      />
      <div className="relative aspect-phone overflow-hidden rounded-screen bg-white">
        <img
          src={DOWNLOAD.screenshot}
          srcSet={`${DOWNLOAD.screenshot} 504w, ${DOWNLOAD.screenshot2x} 1008w`}
          sizes="(min-width: 640px) 300px, 270px"
          width="1008"
          height="1458"
          alt={DOWNLOAD.screenshotAlt}
          loading="lazy"
          className="h-auto w-full object-contain"
        />
      </div>
    </div>
  );
}

export default function Download() {
  return (
    <section
      id="download"
      data-testid="download-section"
      className="section-pad relative overflow-hidden bg-navy-950 text-white"
    >
      <div
        className="absolute inset-0 bg-blueprint-dark [mask-image:radial-gradient(ellipse_70%_70%_at_70%_40%,black_20%,transparent_100%)]"
        aria-hidden="true"
      />
      <div
        className="absolute -right-40 top-1/2 h-[540px] w-[540px] -translate-y-1/2 rounded-full bg-navy-700/30 blur-[140px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <SectionHead
            dark
            eyebrow={DOWNLOAD.eyebrow}
            title={
              <>
                Take <span className="whitespace-nowrap">Infra Digest</span> with you.
              </>
            }
          />
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-md text-body-sm text-white/65 md:mt-12 md:text-body">{DOWNLOAD.sub}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10">
              <a
                href={SITE.playStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="download-play-button"
                className="group inline-flex items-center gap-4 rounded-2xl bg-white px-7 py-4 text-navy-900 transition-colors duration-300 hover:bg-navy-100"
              >
                <PlayStoreIcon className="h-8 w-8 transition-transform duration-300 group-hover:scale-110" />
                <span className="text-left leading-tight">
                  <span className="block text-label uppercase text-navy-900/60">
                    {DOWNLOAD.ctaTop}
                  </span>
                  <span className="block font-display text-xl font-bold">{DOWNLOAD.ctaMain}</span>
                </span>
              </a>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.2}>
            <PhoneMock />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
